export default "__VITE_ASSET__D5bm4ZKr__"